import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";

import {getSmartWalletPage} from '../../redux/actions';
import {getMediaPath, convertToSortedArray} from "../../app/functions";

import './wallet_page.scss';

import * as routes from '../../constants/routes';

//components
import DynamicLink from  '../../components/dynamic_link/index';
import Slider from 'react-slick';
import BreadCrumbs from '../../components/common/bread_crumbs';

//assets
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import slider_arrow from 'assets/icons/arrow-black.svg';
import wallet_girl from 'assets/mock/wallet-page-girl.png';
import ImageHeader from "../../components/image-header";


class WalletPage extends Component{

    constructor(props){
        super(props);

        this.getSlides = this.getSlides.bind(this);
    }

    componentDidMount(){
        this.props.getSmartWalletPage();
        // this.props.history.push(routes.home);
    }

    getSlides(){
        let isMobile = this.props.deviceState === 'mobile';

        const data = this.props.data.sliders;
        let slides = [];

        for (let key in data) {
            slides.push(
                <div className='slide' key= { key }>
                    <div className="desktop-wrapper">
                        <img className="slide-image" src={getMediaPath(isMobile ? data[key].mobileImagePath : data[key].imagePath)} alt='/'/>
                        <div className='points-container'>
                            <h3 className='title'>{data[key].headline}</h3>
                            {data[key].text_fields.map((item,index)=>{
                                return (
                                    <div className='point-wrap' key= { index }>
                                        <div className='red-point'>{index + 1}</div>
                                        <span key={index} className='point'>{item}</span>
                                    </div>)
                            })}
                        </div>
                    </div>
                </div>
            )
        }

        return slides;
    }

    getCardDetails = () => {
        const data = convertToSortedArray(this.props.data.about);

        let res = [];

        data.forEach(item => {
            res.push(
                <div key={item['obj_id']} className='card-wrapper'>
                    <img src={getMediaPath(item['imagePath'])} alt='/'/>
                    <h3 className='card-title'>{item.title}</h3>
                    <div className='content'>{item.content}</div>
                </div>
            )
        });

        return res;
    };


    render(){

        let data = this.props.data;

        let isMobile = this.props.deviceState === 'mobile';

        const isLaptopOrDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop-large';

        let initial_slide = 1;

        if(data) {
            initial_slide = Object.keys(data.sliders).length - 1;
        }

        const settings = {
            dots:true,
            arrows:true,
            infinite:false,
            rtl:true,
            speed:500,
            draggable:false,
            initialSlide: initial_slide,
            slidesToShow:1,
            slidesToScroll:1,
            nextArrow: <SliderArrow customClass="slider-next" />,
            prevArrow: <SliderArrow customClass="slider-prev" />
        };

        return(
            <section className='wallet_page'>
                {data &&
                <Fragment>
                    <ImageHeader
                        image={getMediaPath(isMobile ? data.header.mobileImagePath : data.header.imagePath)}
                        title={data.header.title}
                        subtitle={data.header.content}
                    />

                    <BreadCrumbs root={{text:'דף הבית', route: routes.home}}/>

                    <div className='intro'>
                        <div className='intro-desc'>
                            <h2 className='intro-title'>{this.props.text['smart_wallet_intro_title']}</h2>
                            <div className='intro-text'>{data.body.title}</div>
                            <div className='links-container'>
                                <DynamicLink className='link wallet-benefits' to='/' data={data.body.link2}>
                                    {data.body.link2.btnText}
                                </DynamicLink>
                            </div>
                        </div>
                        <iframe src={data.body.videoLink} frameBorder="0"
                                title="הארנק החכם"
                                referrerPolicy="strict-origin-when-cross-origin"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen></iframe>
                    </div>

                    <div className="about">
                        <div className='about-wrapper'>
                            <h3 className='title'>{this.props.text['smart_wallet_about']}</h3>
                            <div className='cars-container'>
                                {this.getCardDetails()}
                            </div>
                        </div>
                        <div className='how-to-use'>
                            <h3 className='title'>{this.props.text['smart_wallet_way_of_use']}</h3>
                        </div>
                    </div>

                    <div className='instructions'>
                        {(Object.keys(data.sliders).length > 0) &&
                        <Slider className='instructions-slider' {...settings}>
                            {this.getSlides()}
                        </Slider>
                        }
                        {isLaptopOrDesktop &&
                            <img className='wallet-girl-img' src={getMediaPath(wallet_girl)} alt='/'/>
                        }
                    </div>
                    <div className="extra-msg">
                        <div className='links-container'>
                            <DynamicLink className='link wallet-benefits' to='/' data={data.body.link2}>
                                {data.body.link2.btnText}
                            </DynamicLink>
                        </div>
                        <div className='policy'>{this.props.text.smart_wallet_supplier}
                            <DynamicLink data={data.body.termsOfUseLink} className="link">
                                בתקנון
                            </DynamicLink>
                        </div>
                    </div>
                </Fragment>
                }
            </section>
        )
    }
}

function SliderArrow(props) {
    const { onClick, customClass } = props;
    return (
        <div className={customClass } onClick={onClick}>
            <img src= { getMediaPath(slider_arrow) } alt="" />
        </div>
    );
}

const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.Translations,
        data: store.data.WalletPage,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getSmartWalletPage:()=> dispatch(getSmartWalletPage()),
    }
};


export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(WalletPage);
